// extracted by mini-css-extract-plugin
export default {"root":"mupYTr","input":"Q8YBTd","charsLeftCount":"H_quDh"};